// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.


export let MathUtils = function () { };

MathUtils.regexpPrecision = /(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/;
MathUtils.MATH_ROUND_EPSILON = 0.000000001;

// Polyfill.
MathUtils.trunc = Math.trunc || function (x)
{
    return x < 0 ? Math.ceil(x) : Math.floor(x);
};


MathUtils.TruncateDouble = function (value, signCount)
{
    if (!value)
        return 0        // -0 fix #98014

    let factor = Math.pow(10, signCount);
    let epsilon = value > 0 ? MathUtils.MATH_ROUND_EPSILON : -MathUtils.MATH_ROUND_EPSILON;//#85860 
    return MathUtils.trunc((value * 10 + epsilon) * factor / 10) / factor;  // #85574 //#85860 
}

// WARNING. May cause minor precision errors.
// отбрасывание до инкремента
MathUtils.RoundToIncrement = function (value, roundToValue)
{
    if (roundToValue <= 0)
        return value;

    //+hsa - на сервере используют математическое округление
    return Math.round(value / roundToValue + MathUtils.MATH_ROUND_EPSILON) * roundToValue;
}

MathUtils.RoundTo = function (number, roundTo)
{
    if (roundTo == 0)
        return number;

    if (number == 0)
        return number;

    var rounded = Math.round(number / roundTo) * roundTo;
    return Math.abs(rounded) >= roundTo ? rounded : roundTo;
}

MathUtils.RoundDouble = function (value, signCount)
{
    if (!value)
        return 0        // -0 fix #98014

    let factor = Math.pow(10, signCount);
    let epsilon = value > 0 ? MathUtils.MATH_ROUND_EPSILON : -MathUtils.MATH_ROUND_EPSILON;//#85860 
    return Math.round((value * 10 + epsilon) * factor / 10) / factor;  // #85574 //#85860 
}

MathUtils.Round = function (value, points)
{
    let f = Math.pow(10, points);
    return Math.round(value * f) / f;
}

MathUtils.equalToEpsilon = function (value1, value2)     // проверяет равны ли величины с точностью до MathUtils.MATH_ROUND_EPSILON = 0.000000001
{
    return Math.abs(value1 - value2) < MathUtils.MATH_ROUND_EPSILON
}

// TODO. Rename. Remove duplicates if exist.
// Arithmetic operation result precision fix.
// http://www.jacklmoore.com/notes/rounding-in-javascript/
MathUtils.fixFloatPrecision = function (value, decimals)
{
    decimals = decimals || 0

    // Alternative version with rounding down of decimal of 5.
    // E.g. Number(1.005.toFixed(2)) -> 1 instead of 1.01)
    // return Number(value.toFixed(2))

    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)
}

MathUtils.formatDoubleValueUsePrecision = function (value, prec)
{
    return MathUtils.formatDoubleValueUseFactor(value, Math.pow(10, prec), prec);
};

// TODO. Same as MathUtils.RoundToIncrement?
MathUtils.formatDoubleValueUseFactor = function (value, factor, precision)
{
    value = value || 0
    if (value === 0)
    {
        return value
    }

    factor = factor || 0
    if (factor === 0)
    {
        return value
    }

    let rounded = Math.round(value / factor) * factor

    if (precision)
        rounded = MathUtils.TruncateDouble(rounded, precision)      //#98370

    return Math.abs(rounded) >= factor ? rounded : factor
}


//TODO
Math.log10 = Math.log10 || function (x)
{
    return Math.log(x) * Math.LOG10E;
};
MathUtils.GetValuePrecision = function (value, precisionIncr, minPrecision = -2)
{
    if (value == 0 || isNaN(value))
        return 0;

    value = Math.abs(value);

    var precision = Math.log10(value);

    if (precision > 0)
    {
        var fraction = value % Math.floor(value);   // .Net: value % (int)value
        if (fraction != 0)
            precision = Math.abs(Math.log10(fraction)) + precisionIncr;
        else
            precision = 0;
    }
    else
        precision = Math.abs(precision) + precisionIncr;

    return minPrecision != -1 && minPrecision >= precision ? minPrecision : precision;
}

// http://stackoverflow.com/questions/10454518/javascript-how-to-retrieve-the-number-of-decimals-of-a-string-number
MathUtils.getPrecision = function (value)
{
    var match = ('' + value).match(MathUtils.regexpPrecision);
    if (!match) { return 0; }
    return Math.max(
        0,
        // Number of digits right of decimal point.
        (match[1] ? match[1].length : 0)
        // Adjust for scientific notation.
        - (match[2] ? +match[2] : 0));
};

MathUtils.IsNullOrUndefined = function (o) { return o === null || o === undefined }

// Получить котичество знаков после точки
MathUtils.GetDecimalPlaces = function (value, max)      // вероятно стоит отказаться от использования - performance test показал что этот метод на ~35% менее эффективный в сравнении с MathUtils.getPrecision (на случайных числах десятичной записи от 0 до 8 точек после запятой)
{
    if (MathUtils.IsNullOrUndefined(value))
        return null

    let str = value.toString()
    let spl = str.split('.')

    let places = 0;
    if (spl.length > 1)
        places = spl[1].length;
    else
    {
        spl = str.split("e-");
        if (spl.length > 1)
            places = parseInt(spl[1]);
    }

    return places;
}

MathUtils.EPS_ROUNDING_REGEXP = /0+$/;
MathUtils.EpsTableFormat = {};

MathUtils.formatValueWithEps = function (numb)
{
    if (!numb)
        return "0"
    let res = numb.toString();
    if (res.indexOf('e') !== -1)
    {
        res = MathUtils.EpsTableFormat[numb] || numb.toFixed(20).replace(MathUtils.EPS_ROUNDING_REGEXP, '');
        if (!MathUtils.EpsTableFormat[numb])
            MathUtils.EpsTableFormat[numb] = res;
    }

    return res
};

MathUtils.ProcessNaN = function (value, defaultValue)
{
    defaultValue = defaultValue || 0
    return value === null || isNaN(value) ? defaultValue : value

    return !value.HasValue || double.IsNaN(value.Value) ? defaultValue : value.Value
}

MathUtils.isValueMultipleToStep = function (value, step, stepPrecision)
{
    let curValuePrecision = this.getPrecision(value);
    if (curValuePrecision > stepPrecision) return false;

    let multiplier = Math.pow(10, stepPrecision);

    let intValue = Math.round(value * multiplier);
    let intStep = Math.round(step * multiplier);

    return intValue % intStep === 0;
};

export const DECIMAL_SEPARATOR = (() =>
{
    let tmp = new Intl.NumberFormat(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 })
    return tmp.format(1).charAt(1)
})()